import { render } from "./Translation.vue?vue&type=template&id=132dcd24"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"
script.render = render

export default script